import React from 'react';
import fr from 'facet-rest';
import { navigateTo } from 'Helpers/Redirect';
import { changePasswordPath, changePasswordPathExperimental } from 'Consts/Strings';
import useHomeContext from 'Context/HomeContext';
import { FDTextButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

export const NavigateToPasswordResetExperimentalButton = () => {
  const { homeResource } = useHomeContext();

  const navigateToPath = homeResource.withRelationship(fr.relationships.newAuth2025IsStable.name,
    () => changePasswordPath,
    () => changePasswordPathExperimental);

  return homeResource.withRelationship(fr.relationships.resetPassword.name, (rel) => {
    return (
      <FDTextButton
        {...dataAttrs('authentication-forgot-password-button')}
        onClick={() => navigateTo(navigateToPath)}
        label={rel.meta('prompt')}
      />
    );
  }, () => null);
};
